export const stripSpaces = (val: string) => val.replace(/ /g, '')
